/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgInhaler = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M21.742 18.639a1 1 0 1 1 .517 1.932 1 1 0 0 1-.517-1.932z" />
        <path
          clipRule="evenodd"
          d="M6.165 2.108c.726 0 1.358.48 1.56 1.166l.034.141.44 2.196c.471.166.855.546 1.012 1.045l.041.158 1.54 7.394h3.469c.699 0 1.314.446 1.537 1.098l.04.133.732 2.933a1.625 1.625 0 0 1-1.576 2.02H4.813a1.626 1.626 0 0 1-1.6-1.334L1.253 8.284a1.623 1.623 0 0 1 .478-1.466l-.468-2.817a1.625 1.625 0 0 1 1.602-1.893zM3.038 8.122l1.906 10.486h7.28l-.654-2.617h-.907c-.77 0-1.434-.54-1.59-1.293l-1.537-7.37zm11.024 10.486h.729l-.654-2.617h-.729zM3.444 6.24 6.4 5.717l-.364-1.825H3.053z"
          fillRule="evenodd"
        />
        <path d="M18.327 17.483a1 1 0 1 1 .517 1.933 1 1 0 0 1-.517-1.933zm2.38-1.708a1 1 0 1 1 .518 1.932 1 1 0 0 1-.518-1.932zm-2.415-2.155a1 1 0 1 1 .517 1.932 1 1 0 0 1-.517-1.932zm2.346-1.968a1 1 0 1 1 .517 1.933 1 1 0 0 1-.517-1.933z" />
      </g>
    </g>
  </Icon>
);
export { SvgInhaler as Inhaler };
